<template>
  <Dialog v-model:visible="visible"
    :style="{ width: '700px', maxHeight: '900px' }"
    :modal="true"
    :contentStyle="{'overflow': 'visible'}"
    ref="dialog"
    @show="onShow"
    @hide="onHide"
    >
    <template #header>
      <h2>Контрагенти</h2>
    </template>
    <div class="lll"></div>
    <Contragents @select="onSelect"/>

    {{data}}
    <template #footer>
      <ButtonsApplyCancel @apply="onSave" @cancel="$refs.dialog.close()"/>
    </template>
  </Dialog>

</template>

<script>
export default {
  inheritAttrs: false,
  emits: {
    load: null,
    save: null,
    select: null
  },
  data() {
    return {
      visible: false,
      data: {
        vatP: 22
      }
    }
  },

  created() {
  },

  props: {
    title: String,
    selected: Object
  },

  methods: {
    currency(f) {
      return f.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    onShow() {
      this.data = {}
      this.$emit('load', this.data);
    },
    onHide() {
      this.data = {};
    },
    onSave() {
      this.$emit('save', this.data);
      this.$refs.dialog.close();
    },
    onSelect(data) {
      this.$emit('select', data);
      console.log(data);
      this.$refs.dialog.close();
    },
    open() {
      this.visible = true;
    }
  },

  computed: {
    net: function() {
      if (this.data.quantity && this.data.price) {
        return this.data.quantity *  this.data.price;
      }
      return 0;
    },
    vat: function() {
      if (this.data.vatP) {
        if (this.data.quantity && this.data.price) {
          return this.data.quantity *  this.data.price * (this.data.vatP / 100);
        }
      }
      return 0;
    },
    gros: function() {
      if (this.data.quantity && this.data.price) {
        return this.data.quantity *  this.data.price;
      }
      return 0;
    }
  }
}
</script>
